class ContatoModel {

    id: number | null;
    id_entidade: number | null;
    tipo_contato: string | null;
    descricao: string | null;
    responsavel: string | null;
    setor: string | null;

    constructor() {
        this.id = null;
        this.id_entidade = null;
        this.tipo_contato = null;
        this.descricao = null;
        this.responsavel = null;
        this.setor = null;
    }

}

export default ContatoModel;
